module.exports = global["Page"] = require("-!e:\\build\\Roadmap-Release-19.1\\Source\\Nis.WebAgent\\frontend\\node_modules\\awesome-typescript-loader\\dist\\entry.js??ref--1!e:\\build\\Roadmap-Release-19.1\\Source\\Nis.WebAgent\\frontend\\node_modules\\tslint-loader\\index.js!.\\Page.ts");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?Page!./src/globals/Page.ts-exposed
// module id = 234
// module chunks = 8 14